import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/SignPunsApi";
import { SITE_ROLE_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import SiteRoleForm from "./SiteRoleForm";
import { getAllRoles } from "../OrgSlice";
import "react-toastify/dist/ReactToastify.css";

const SiteRole = () => {
  const [siteRoleDetails, setSiteRoleDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteSiteRole, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getSiteRoleRecords,
    {
      data: siteRoleList,
      isError: isSiteRoleError,
      isLoading: isSiteRoleLoading,
      isFetching: isSiteRoleFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Role Name",
      accessor: "RoleType.Name",
      filter: true,
    },
    {
      Header: "User Name",
      accessor: "User.Name",
      filter: true,
    },
  ];

  const handleEditData = (siteRoleData) => {
    setSelectedRecord(siteRoleData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteSiteRole({
      entity: "SiteRole",
      id: selectedRecord.Id,
      tag: SITE_ROLE_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Role deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getSiteRoleRecords({
      entity: "SiteRole",
      expand: { RoleType: {}, User: {} },
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: SITE_ROLE_TAG,
    });
    setSiteRoleDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isSiteRoleLoading &&
      !isSiteRoleError &&
      siteRoleList &&
      !isSiteRoleFetching
    ) {
      dispatch(getAllRoles(siteRoleList.value));
      let siteRoleData = [...siteRoleList.value];
      setSiteRoleDetails({
        ...siteRoleDetails,
        tableRowsData: siteRoleList.value ? siteRoleData : [],
        totalData:
          siteRoleList && siteRoleList["@odata.count"]
            ? siteRoleList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [isSiteRoleError, siteRoleList, isSiteRoleLoading, isSiteRoleFetching]);

  return (
    <Container>
      <Row>
        {siteRoleDetails && (
          <DataReactTable
            reactTableData={siteRoleDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Site Role"
            isFetching={isSiteRoleFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Site Role`}
          header
          btn="Success"
          message={
            <SiteRoleForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.User.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default SiteRole;
